<template>
  <div class="slider decors-background-fond-etoile">
    <Header
      v-if="!$isMobile"
      class="slider--logo"
    />
    <search class="slider--searchType">
      <div class="before decors-background-carrousel-menu-coin-gauche" />
      <FilterTypeToggleButton />
    </search>
    <div class="slider--buttons">
      <button
        class="decors-icons-cta-arrow"
        :class="{ disabled: current === 0 }"
        @click="decrease"
      />
      <button
        class="decors-icons-cta-arrow"
        :class="{ disabled: current === filterValues.length - 1 }"
        @click="increase"
      />
    </div>
    <div
      v-touch:swipe.left="increase"
      v-touch:swipe.right="decrease"
      class="slider--wrapper"
    >
      <search class="slider--searchValue">
        <FilterValueSlider />
      </search>
      <transition
        name="perso"
        appear
      >
        <div class="slider--chars decors-personnages-homepage" />
      </transition>
    </div>
  </div>
</template>
<script>
import Header from '@/components/common/header/Header.vue';
import FilterTypeToggleButton from '@/components/common/filter/FilterTypeToggleButton.vue';
import FilterValueSlider from '@/components/common/filter/slider/FilterValueSlider.vue';
import mixin from '@/components/common/filter/FilterMixin.vue';

export default {
  name: 'FilterHeader',
  components: {
    Header,
    FilterTypeToggleButton,
    FilterValueSlider,
  },
  mixins: [mixin],
  data() {
    return {
      current: 0,
    };
  },
  computed: {
  },
  watch: {
    filterType: {
      immediate: true,
      handler() {
        this.current = 0;
      },
    },
    filterValue() {
      this.current = this.filterValues.findIndex(val => val.value === this.filterValue);
    },
    current() {
      const value = this.filterValues[this.current].value;
      this.$store.commit('setFilterValue', value);
    },
  },
  methods: {
    increase() {
      this.current = Math.min(this.current + 1, this.filterValues.length - 1);
    },
    decrease() {
      this.current = Math.max(this.current - 1, 0);
    },
  },
};
</script>
<style lang="stylus" scoped>
.slider {
  border: 1px solid white;
  position: relative;
  height: 520px;
  background-size: cover;
  width: calc(100% - var(--app-gutter));
  max-width: $container-width;

  +mobile() {
    height: 530px;
  }

  +mobile(){
    width: calc(100% - 10px);
  }

  &--logo {
    position: absolute;
    top: 20px;
    left: 20px;
  }

  &--searchType {
    display: block;
    width: fit-content;
    position: absolute;
    top: -1px;
    right: 140px;
    background: $cl-yellow;
    height: 50px;
    display: flex;
    align-items: center;
    padding: 0 20px 0 2px;
    & .before {
      position: absolute;
      left: 1px;
      top: 0;
      transform: translateX(-100%);
    }

    +mobile() {
      top: 0;
      right: 0;
      left: 0;
      width: 100%;
      padding: 0 8px 0 8px;

      & .before {
        display: none;
      }
    }
  }

  &--buttons {
    position: absolute;
    top: -1px;
    right: -1px;
    width: 141px;
    height: 50px
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 20px;
    background: $cl-blue;
    border-bottom: 1px solid white;
    pointer-events: auto;

    +mobile() {
      top: auto;
      bottom: -1px;
      border-top: 1px solid white;
      border-left: 1px solid white;
      border-bottom: none;
    }
    button {
      border: none;
      cursor: pointer;
      transform-origin: center;
      aspect-ratio 18/13;
      width: 30px;
      height: auto;
      background-size: cover;
      transition: transform 0.3s ease-out;
      &.disabled {
        opacity: 0.5;
        pointer-events: none;
      }
      +desktop() {
        &:hover {
          transform: translateX(5px);
        }
      }
    }

    button:first-child {
      transform: rotate(180deg);
      +desktop(){
        &:hover {
          transform: rotate(180deg) translateX(5px);
        }
      }
    }
  }

  &--wrapper {
    position: relative;
    height: 100%;
    width: 100%;
    overflow: hidden;
    pointer-events: none;
    +desktop() {
    }
  }

  &--searchValue {
    display: block;
    top: 70px;
    position: relative
    z-index: 2;
    +desktop() {
      top: 28px;
    }
  }

  &--chars {
    margin: auto;
    pointer-events: none;
    position: absolute;
    top: 55px;
    left: 50vw;
    transform: translateX(-50%);

    /* Fixed the blurry effect occuring due to the transform resulting in half pixel placement*/
    +mobile() {
      width: 266px;
    }
    /* end of fix */

    +desktop() {
      top: auto;
      bottom: -70px;
      left: -70px;
      transform: none;
    }

    +vue-transition("perso") {
      opacity: 0;
      transform: translateX(-10px);

      +mobile() {
        transform: translateX(-50%) translateY(10px);
      }
    }
  }
}
</style>
